import { useEffect, useState } from 'react';

type HostState = { cameraOff: boolean; micMuted: boolean };
// The isolated preview is also hosted in production; ordinary service pages
// never carry this marker and continue to use actual stream metadata.
const isLocalReview = () => !!document.querySelector('meta[name="fanbird-local-review"]');
function initialState(): HostState | null {
  if (!isLocalReview()) return null;
  const data = document.documentElement.dataset;
  if (!['true', 'false'].includes(data.reviewCameraOff || '') || !['true', 'false'].includes(data.reviewMicMuted || '')) return null;
  return { cameraOff: data.reviewCameraOff === 'true', micMuted: data.reviewMicMuted === 'true' };
}

/** Only the isolated review document can simulate the stream's host state. */
export default function useReviewHostStatus() {
  const [state, setState] = useState<HostState | null>(initialState);
  useEffect(() => {
    if (!isLocalReview()) return;
    const update = (event: Event) => {
      const value = (event as CustomEvent).detail;
      if (typeof value?.cameraOff === 'boolean' && typeof value?.micMuted === 'boolean') {
        setState({ cameraOff: value.cameraOff, micMuted: value.micMuted });
      }
    };
    window.addEventListener('fanbird-local-review:devices', update);
    return () => window.removeEventListener('fanbird-local-review:devices', update);
  }, []);
  return state;
}
